export default "__VITE_ASSET__25abca4a__"